/*
 * Copyright (c) 2026. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import _defaultTo from "lodash/defaultTo";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";

dayjs.extend(customParseFormat);
dayjs.extend(utc);

export const formatTemporalValue = (value: string | null, format: string | null): string => {
  if (!value) {
    return "";
  }

  if (format === "date") {
    const date = dayjs.utc(value, "YYYY-MM-DD", true);
    return date.isValid() ? date.format("DD.MM.YYYY") : value;
  }

  if (format === "time") {
    const inputFormat = value.length === 8 ? "HH:mm:ss" : "HH:mm";
    return dayjs.utc(value, inputFormat, true).isValid() ? `${value} Uhr` : value;
  }

  if (format === "dateTime") {
    const parts = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}(?::\d{2})?)(Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)?$/.exec(value);

    if (!parts) {
      return value;
    }

    const inputFormat = parts[2].length === 8 ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
    const date = dayjs.utc(`${parts[1]} ${parts[2]}`, inputFormat, true);

    if (!date.isValid()) {
      return value;
    }

    // Preserve the approved wall time and any explicit offset instead of shifting it to the browser timezone.
    const offset = parts[3] === "Z" ? "UTC" : `UTC${parts[3]}`;
    return `${date.format("DD.MM.YYYY")}, ${parts[2]} Uhr${parts[3] ? ` (${offset})` : ""}`;
  }

  return value;
};

export const convertToLocaleString = (value: string) => {
  if (_defaultTo(value, "") === "") {
    return "";
  }

  const isoDayjs = dayjs(value, undefined, true);
  if (isoDayjs.isValid()) {
    return isoDayjs.format("DD.MM.YYYY");
  }

  const localeDayjs = dayjs(value, ["DD.MM.YYYY", "DD.M.YYYY", "D.MM.YYYY", "D.M.YYYY"], true);
  if (localeDayjs.isValid()) {
    return localeDayjs.format("DD.MM.YYYY");
  }

  return "";
};
